// extracted by mini-css-extract-plugin
export default {"cardContainer":"AddNote_cardContainer__LmotH","header":"AddNote_header__Y3V-H","body":"AddNote_body__XcyS+","actions":"AddNote_actions__etgyj","formGroup":"AddNote_formGroup__rNHrA"};